<template>
	<v-layout row wrap background class="section-slider" id="sectionslider">
		<v-flex xs12 hidden-sm-and-down>
			<h2 class="section-slider-title secondary--text">TU APLICATIVO CASAMARKET INCLUYE 3 MÓDULOS</h2>
		</v-flex>
		<v-flex xs12 class="container">
			<slider
				animation="fade"
				:speed="2000"
				:interval="6000"
				:stop-on-hover="true"
				:touch="false"
				height="100%"
				class="section-slider-slides"
			>
				<slider-item v-for="slide in slides" :key="slide.id">
					<v-layout
						row wrap white
						class="section-slider-slide"
					>
						<v-flex
							xs12 md6 secondary--text
							class="section-slider-slide-left"
						>
							<h3 class="section-slider-slide-title">{{ slide.title }}</h3>
							<h1 class="section-slider-slide-title section-slider-slide-title-big">CASAMARKET APP</h1>
							<v-layout
								row wrap v-for="action in slide.actions"
								:key="action.id" align-center
								class="section-slider-slide-action"
							>
								<v-flex xs1>
									<img
										src="/static/images/icons/icon-check-CM.svg"
										alt="viñeta para texto"
										height="20"
									/>
								</v-flex>
								<v-flex xs8>
									{{ action.text }}
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex
							xs12 md6
							class="section-slider-slide-right"
						>
							<img
								:src="slide.image"
								:alt="slide.alt"
								:class="slide.class"
							/>
						</v-flex>
					</v-layout>
				</slider-item>
			</slider>
		</v-flex>
	</v-layout>
</template>
<script>

function data() {
	return {
		slides: [
			{
				id: 2,
				actions: [
					{
						id: 1,
						text: 'Recibe en tu celular los pedidos que realicen tus clientes.',
					},
					{
						id: 2,
						text: 'Mantén surtida tu app, y acompaña tus productos con fotos.',
					},
					{
						id: 3,
						text: 'Conoce más a tus clientes: Historial de pedidos por fecha, hora, precio, frecuencia, etc.',
					},
					{
						id: 4,
						text: 'Conoce más tu negocio: Descubre qué productos se venden más, la recurrencia, el ticket promedio etc.',
					},
				],
				alt: 'CasaMarket para ti',
				class: 'section-slider-slide-2',
				image: '/static/images/sliders/slide-2-CM.png',
				title: 'Para ti',
			},
			{
				id: 1,
				actions: [
					{
						id: 1,
						text: 'Podrás agregar o eliminar productos, cambiar precios, y si no sabes cómo hacerlo, nosotros te ayudamos.',
					},
					{
						id: 2,
						text: 'Podrás tener la base de datos de tus clientes:  Conoce sus hábitos de consumo y podrás comunicarle promociones.',
					},
					{
						id: 3,
						text: 'Podrás agregar productos a través de un lector de códigos de barras.',
					},
					{
						id: 4,
						text: 'Podrás ver los estados de los pedidos para organizarte mejor',
					},
					{
						id: 6,
						text: 'Podrás acceder a un mapa.',
					},
				],
				alt: 'administrador mi casamarket',
				class: 'section-slider-slide-1',
				image: '/static/images/sliders/slide-1.png',
				title: 'Administrador',
			},
			{
				id: 3,
				actions: [
					{
						id: 1,
						text: 'Tu cliente podrá realizar sus pedidos a través del celular.',
					},
					{
						id: 2,
						text: 'Cuando el pedido esté listo, se le notificará para que recoja su pedido.',
					},
					{
						id: 3,
						text: 'Podrá hacer comentarios adicionales a su pedido.',
					},
					{
						id: 4,
						text: 'Podrá ver su historial de pedidos y el estado de su cuenta.',
					},
					{
						id: 5,
						text: 'Podrá efectuar los pagos de manera online sin tener que ir al comercio.',
					},
				],
				alt: 'CasaMarket para tu cliente',
				class: 'section-slider-slide-3',
				image: '/static/images/sliders/slide-3.png',
				title: 'Para tu cliente',
			},
		],
		swiperOptions: {
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 100500,
				disableOnInteraction: true,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		},
	};
}
export default {
	name: 'section-slider',
	data,
};
</script>
<style lang="scss">
	.section-slider {
		padding: 36px 1% 48px;

		@media (min-width: 1024px) {
			padding: 0px 0px 121px;
		}
	}

	.section-slider-title {
		font-size: size(large30);
		font-weight: weight(w900);
		padding: 103px 0px 71px;
		text-align: center;
	}

	.section-slider-slide {
		border-radius: 19px;
		box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.06);
		height: 100%;

		&-title {
			font-size: size(large30);
			font-weight: weight(w900);
			line-height: 1;
			text-align: center;

			@media (min-width: 1024px) {
				font-size: size(large38);
				text-align: left;
			}

			&:not(.section-slider-slide-title-big) {
				padding: 48px 0px 0px;

				@media (min-width: 1024px) {
					padding: 56px 0px 0px;
				}
			}

			&-big {
				font-size: size(large32);
				padding: 0px 0px 28px;

				@media (min-width: 1024px) {
					font-size: size(large44);
					padding: 0px 0px 30px;
				}
			}
		}

		&-action {
			border: 1px solid color(primary-cs);
			border-radius: 10px;
			line-height: 1;
			margin: 0px auto 12px;
			max-height: 88px;
			max-width: 320px;
			min-height: 56px;
			padding: 4px 0px 4px 3%;
			width: 90%;

			&:last-of-type {
				margin: 0px auto 0px;

				@media (min-width: 1024px) {
					margin: 0px 0px 12px;
					max-height: 66px;
				}
			}

			@media (min-width: 1024px) {
				margin: 0px 0px 23px;
				max-height: 66px;
			}
		}

		&-1 {
			height: 224px;

			@media (min-width: 1024px) {
				height: 242px;
				margin-top: 190px;
			}

			@media (min-width: 1400px) {
				height: 371px;
				margin-top: 106px;
			}
		}

		&-2 {
			height: 352px;
			margin-top: 0px;

			@media (min-width: 1024px) {
				height: 452px;
				margin-top: 106px;
			}
		}

		&-3 {
			height: 352px;
			margin-top: 0px;

			@media (min-width: 1024px) {
				height: 452px;
				margin-top: 106px;
			}
		}

		&-left {
			height: 45%;

			@media (min-width: 1024px) {
				height: 100%;
				padding-left: 10%;
			}
		}

		&-right {
			text-align: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home/section-slider.vue